<template>
  <div v-if="product">
    <v-select
      v-for="(option, index) in product.options"
      :label="option.name"
      :items="option.values"
      itemText="value"
      :value="getValue(option)"
      @input="selectedValue => selectVariant(option, selectedValue)"
      :key="option.name + index"
    />
    <slot></slot>
    <the-price v-if="selectedVariant && selectedVariant.price" class="justify-end" :price="selectedVariant.price" />
    <div v-else class="text-end body-1 red--text">Invalid Choice</div>
  </div>
</template>
<script>
import thePrice from './thePrice.vue';
export default {
  name: 'ProductSelection',
  components: { thePrice },
  props: {
    value: {
      type: Object,
      default: function () { return {}; }
    },
    product: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data: function () {
    return {
      selectedOptions: []
    };
  },
  methods: {
    selectVariant: function (option, selectedValue) {
      const selectedOption = this.selectedOptions.find(o => option.name === o.name);
      if (selectedOption) {
        selectedOption.selectedValue = selectedValue;
      } else {
        this.selectedOptions.push({
          name: option.name,
          selectedValue
        });
      }

      this.selectedVariant = this.product.variants.find(variant => {
        return this.selectedOptionsMatch(variant.selectedOptions);
      });
    },
    selectedOptionsMatch: function (variantOptions) {
      for (const variantOption of variantOptions) {
        const selectedOption = this.selectedOptions.find(option => variantOption.name === option.name);
        if (!selectedOption || selectedOption.selectedValue !== variantOption.value) {
          return false;
        }
      }
      return true;
    },
    resetDefaults: function () {
      this.selectedOptions = [];
      this.selectedVariant = null;
    },
    setInitialVariant: function (product) {
      this.selectedOptions = [];
      const variant = product.variants[0];
      for (const variantOption of variant.selectedOptions) {
        this.selectedOptions.push({
          name: variantOption.name,
          selectedValue: variantOption.value
        });
      }
      this.selectedVariant = variant;
    },
    getValue: function (option) {
      const selectedOption = this.selectedOptions.find(o => o.name === option.name);
      if (selectedOption) {
        return selectedOption.selectedValue;
      }
      return null;
    }
  },
  computed: {
    selectedVariant: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      }
    }
  },
  created: function () {
    if (this.product) {
      this.setInitialVariant(this.product);
    }
  }
};
</script>
